import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Problemtruth() {
  return (
    <section className="platform_feature p-100 text_second_text">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="text-center resp_order"
          >
            <div className="platform_img">
              <StaticImage
                src="../../../images/case-studies/truth-gpt/The_Problem.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={621}
                height={582}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="offset-xl-1 offset-lg-1 my-auto"
          >
            <h2>
              The <span>Problem</span>
            </h2>
            <p>
              The client identified a critical need for a tool to counteract the
              rampant spread of misinformation in the digital landscape.
            </p>
            <p>
              The challenges faced by information seekers, fact-checkers, and
              individuals navigating a sea of digital content prompted the
              client to seek a solution in the form of TruthGPT.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Problemtruth;
